import React from 'react';

import style from './Title.scss';

export const Title = () => (
    <div className={style.item} />
);
